import { AfterViewInit, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { IFilters } from '../../../../../shared/interfaces/filters/filters.interface';
import { FiltersSettingsRef } from '../../../constants/filters-settings-ref.token.const';
import { IFiltersSettings } from '../../../interfaces/filters-settings.interface';
import { FiltersChannel } from '../../../models/filters-channel.model';

@Component({
  standalone: false,
  selector: 'suvo-bi-filters-sidenav',
  templateUrl: './filters-sidenav.component.html',
  styleUrls: ['./filters-sidenav.component.scss'],
})
export class FiltersSidenavComponent implements AfterViewInit {
  @Input() filtersChannel: FiltersChannel;

  @Input() selectOpen = false;
  @Input() showNoneOption = true;
  @Input() autoApplyFilters = true;

  @Input() insertStyles: any = {};
  @Input() exportDisabled = true;

  @Output() filtersManuallyApplied = new EventEmitter<boolean>();

  selectedFilters: IFilters;
  createEvent = new EventEmitter<boolean>();

  currentExportRoute = null;
  onExportScreen = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    @Inject(FiltersSettingsRef) private filtersSettings: IFiltersSettings,
  ) {}

  ngAfterViewInit() {
    this.currentExportRoute =
      this.filtersSettings?.filtersSections?.[this.filtersChannel?.channelName]?.exportRoute;
    this.activatedRoute.url.pipe(take(1)).subscribe((route) => {
      if (route[0]?.path === 'export') {
        this.onExportScreen = true;
      } else {
        this.onExportScreen = false;
      }
    });
  }

  onFiltersManuallyApplied(ev) {
    this.filtersManuallyApplied.next(ev);
  }
}
